import { AlertTriangle } from 'lucide-react'
import { useState } from 'react'

import { useAuth } from '@langmail/shared-ui'

import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { useAccountStatus } from '@/features/auth/hooks/use-account-status'

export function ReconnectBanner() {
  const [isReconnecting, setIsReconnecting] = useState(false)
  const { hasOAuthError, isLoading } = useAccountStatus()
  const { signInWithGoogle } = useAuth()

  const handleReconnect = async () => {
    setIsReconnecting(true)
    const { error } = await signInWithGoogle({ isReconnect: true })
    if (error) {
      console.error('Reconnection error:', error)
      setIsReconnecting(false)
    }
  }

  if (isLoading || !hasOAuthError) {
    return null
  }

  return (
    <Alert className="relative rounded-lg border-warning/40 bg-warning/10 py-2.5">
      <AlertDescription className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0 text-warning" />
        <span className="flex-1 text-[14px] text-muted-foreground">
          Your Gmail connection expired. Reconnect to continue processing emails.
        </span>
        <Button disabled={isReconnecting} onClick={handleReconnect} size="sm" variant="secondary">
          {isReconnecting ? 'Reconnecting...' : 'Reconnect'}
        </Button>
      </AlertDescription>
    </Alert>
  )
}
